'use strict';

var React = require('react');
var Border = require('../common/Border');
var styleHelper= require('../../helper/styleHelper');

/**
 * 顶部操作栏
 */
var TopActionBar = React.createClass({
  render: function () {
    var size = 6;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var bg = styleHelper.getBackgroundColor(this.props);
    var fontStyle = styleHelper.StyleUtil(this.props).text().style;

    var borderStyle = {
      backgroundColor: bg
    };

    var menuStyle = {
      top: (h - 24) / 2
    };
    var menuItemStyle = {
      borderColor: this.props.iconColor
    };


    var backStyle = {
      top: (h - 18) / 2,
      borderColor: this.props.iconColor
    };

    var PHeight = 16;
    var PStyle = $.extend({}, fontStyle, {
      textAlign: 'center',
      lineHeight: PHeight + 'px',
      height: PHeight,
      margin: (this.props.h - PHeight) / 2 + 'px' + ' 0',
      fontSize: this.props.textSize
    });
    
    return (<div className="component-TopActionBar" style={borderStyle}>
      {
        this.props.showMenu &&
        <div className="menu" style={menuStyle}>
          <div className="menu-line" style={menuItemStyle}></div>
          <div className="menu-line" style={menuItemStyle}></div>
          <div className="menu-line" style={menuItemStyle}></div>
        </div>
      }
      <p style={PStyle}>{this.props.text}</p>
      {
        this.props.showBack &&
        <div className="back" style={{height: h }}>
          <div className="back-icon" style={backStyle}></div>
        </div>
      }

    </div>);
  }
});

module.exports = TopActionBar;



// WEBPACK FOOTER //
// ./src/views/Components/TopActionBar.jsx